const createIncidenceUrlById = (id) => `incidencias/${id}`

export default createIncidenceUrlById
